import { render, staticRenderFns } from "./FreeEdmForm.vue?vue&type=template&id=9f4bb11a&"
import script from "./FreeEdmForm.vue?vue&type=script&lang=js&"
export * from "./FreeEdmForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports